import { UiHeadingModel } from "../../models";

export function mockUiHeadingModel({
    id = "heading-1234",
    type = "uiHeading",
    locale = "en",
    content = mockUiHeadingModelContent()
}: Partial<UiHeadingModel> = {}): UiHeadingModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiHeadingModelContent = UiHeadingModel["content"];

export function mockUiHeadingModelContent({
    entryTitle = "Heading",
    text = "Trello brings all your tasks, teammates, and tools together",
    headingLevel = "h1",
    ...optionals
}: Partial<UiHeadingModelContent> = {}): UiHeadingModelContent {
    return {
        entryTitle,
        text,
        headingLevel,
        ...optionals
    };
}
